<template>
  <pages-wrapper>
    <div class="payment">
      <h1 class="payment-title">
        {{ pageTitle }}
      </h1>

      <div
        class="payment-content"
        v-html="GET_FRAGMENT('payment_main')"
      />

      <div class="payment-hint">
        <ol>
          <li>
            <span>Номер карты ‒ 16 цифр на лицевой стороне карты</span>
          </li>
          <li>
            <span>Срок действия в формате ММ/ГГ</span>
          </li>
          <li>
            <span>Имя держателя карты в точности так же, как они написаны на карте</span>
          </li>
          <li>
            <span>CVC/CVV ‒ цифровой номер на обратной стороне карты.</span>
          </li>
        </ol>
        <img :src="cardImage" alt="cardImage">
      </div>

      <p>
        Передача этих сведений производится с соблюдением всех необходимых мер безопасности. Данные будут переданы только на авторизационный сервер Банка по защищенному каналу (протокол SSL 3.0). Информация передается в зашифрованном виде и сохраняется только на специализированном сервере платежной системы. Сайты и магазины не знают и не хранят данные по вашей банковской карте.
      </p>

      <div class="payment-systems">
        <p>Мы принимаем к оплате банковские карты платежных систем:</p>
        <img class="payment-systems__img" :src="systemImage" alt="systems">
      </div>

      <order-support>
        С вопросами обращайтесь в службу поддержки пользователей FUNDAY по почте  <a href="mailto:helpme@fundayshop.com">helpme@fundayshop.com</a> или по телефону <a href="tel:+78007700101">8 800 770-01-01</a> (по России бесплатно), с 7:00 до 22:00 (мск)
      </order-support>
    </div>
  </pages-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
/* Components */
import PagesWrapper from '../../components/info-pages/pages-wrapper';
import OrderSupport from '../../components/account/order-support';
/* Images */
import SystemsImg from '../../assets/images/systems.png'
import CardHintImage from '../../assets/images/card.png'
import pageMetaMixin from '@/mixins/page-meta-mixin';

export default {
  name: 'payment',

  metaInfo() {
    return this.getPageMeta({ pageTitle: this.pageTitle });
  },

  components: {
    OrderSupport,
    PagesWrapper
  },

  mixins: [pageMetaMixin],

  data() {
    return {
      pageTitle: 'Оплата',
      systemImage: SystemsImg,
      cardImage: CardHintImage
    }
  },

  computed: {
    ...mapGetters({
      GET_FRAGMENT: 'staticPages/fragments'
    })
  },

  methods: {
    ...mapActions({
      loadFragment: 'staticPages/loadStaticFragments',
    })
  },

  serverPrefetch() {
    return this.loadFragment({slotName: 'payment_main'});
  }
};
</script>

<style lang="scss">
.payment {
  img {
    width: auto;
  }

  &-hint {
    margin-top: 24px;

    img {
      height: 196px;
      margin-top: 12px;
    }

    li {
      font-size: 14px;
      line-height: 20px;
      font-weight: normal;
    }
  }

  &-systems {
    margin-top: 10px;

    p {
      margin-top: 0;
      margin-right: 15px;
    }

    &__img {
      height: 23px;
    }
  }

  .order-support {
    margin-top: 24px;
    color: $black;
  }
}

@include breakpoint("tablet") {
  .payment {
    &-hint {
      display: flex;

      & > img {
        margin-top: 0;
        min-width: 320px;
      }
    }

    &-systems {
      display: flex;
      align-content: center;
    }
  }
}

@include breakpoint("desktop") {
  .payment {
    &-hint {
      margin-top: 32px;

      img {
        min-width: 456px;
        height: 280px;
      }

      li {
        font-size: 16px;
        line-height: 24px;
      }
    }

    .order-support {
      margin-top: 32px;
      font-size: 16px;
      line-height: 24px;
    }
  }
}
</style>
